import React from 'react';
import { Clock, FolderX, UserX } from 'lucide-react';
export function ProblemSection() {
  return <section className="bg-[#F9F9F9] py-20 px-4" data-id="element-153">
      <div className="max-w-5xl mx-auto" data-id="element-154">
        <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-155">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1A1A1A] mb-6 leading-tight" data-id="element-156">
            ¿Llegás a la intensificación sin tiempo, sin recursos y sin saber
            por dónde empezar?
          </h2>
          <p className="text-lg md:text-xl text-gray-600 leading-relaxed" data-id="element-157">
            Sabemos lo que sentís. Tenes que planificar la intensificación, tus
            estudiantes necesitan apoyo urgente y vos tenés que armar todo desde
            cero, en tiempo récord.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-158">
          {/* Item 1 */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 flex flex-col items-center text-center transition-transform hover:-translate-y-1" data-id="element-159">
            <div className="w-16 h-16 bg-rose-50 rounded-full flex items-center justify-center mb-6" data-id="element-160">
              <Clock className="w-8 h-8 text-[#E91E63]" data-id="element-161" />
            </div>
            <p className="text-[#1A1A1A] font-semibold text-lg" data-id="element-162">
              Sin tiempo para planificar
            </p>
          </div>

          {/* Item 2 */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 flex flex-col items-center text-center transition-transform hover:-translate-y-1" data-id="element-163">
            <div className="w-16 h-16 bg-cyan-50 rounded-full flex items-center justify-center mb-6" data-id="element-164">
              <FolderX className="w-8 h-8 text-[#00BCD4]" data-id="element-165" />
            </div>
            <p className="text-[#1A1A1A] font-semibold text-lg" data-id="element-166">
              Sin recursos listos para usar
            </p>
          </div>

          {/* Item 3 */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 flex flex-col items-center text-center transition-transform hover:-translate-y-1" data-id="element-167">
            <div className="w-16 h-16 bg-rose-50 rounded-full flex items-center justify-center mb-6" data-id="element-168">
              <UserX className="w-8 h-8 text-[#E91E63]" data-id="element-169" />
            </div>
            <p className="text-[#1A1A1A] font-semibold text-lg" data-id="element-170">
              Sin saber qué pide la normativa
            </p>
          </div>
        </div>
      </div>
    </section>;
}